import { useMemo, useState } from "react";
import { supabase } from "../lib/supabase/supabaseClient";
import Button from "../components/atoms/Button/Button";
import { AuthError } from "@supabase/supabase-js";
import {
  errorMessageTranslator,
  ErrorCode,
  isPasswordValid,
} from "./authHelpers";

const UpdatePasswordForm = () => {
  const params = useMemo(() => {
    const hash = window.location.hash.substring(1);
    const searchParams = new URLSearchParams(hash);
    return Object.fromEntries(searchParams.entries());
  }, []);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleForgotPassword = async () => {
    setError(null);

    if (!isPasswordValid(password)) {
      setError("Heslo musí mať aspoň 6 znakov, jedno veľké písmeno a číslo.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Heslá sa nezhodujú");
      return;
    }
    setIsLoading(true);

    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      window.location.href = "/";
    } catch (error: unknown) {
      if (error instanceof AuthError) {
        const errorMessage = errorMessageTranslator(error.code as ErrorCode);
        setError(errorMessage);
      } else {
        setError("Nastala chyba pri prihlasovaní");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (params.error) {
    if (
      params.error === "access_denied" &&
      params.error_code === "otp_expired"
    ) {
      return (
        <div className="dui-auth-page">
          <div className="dui-auth-logo">
            <b>Doktor</b>UI
          </div>
          <div className="dui-auth-form">
            <div className="dui-auth-title">Link bohužiaľ vypršal</div>
            <div>
              Môžte znovu požiadať o obnovenie hesla{" "}
              <a href="/forgot-password">na tomto odkaze</a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="dui-auth-page">
        <div className="dui-auth-logo">
          <b>Doktor</b>UI
        </div>
        <div className="dui-auth-form">
          <div className="dui-auth-title">Nezanáma chyba</div>
          <div>
            Späť na <a href="/login">prihlasovanie</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <form className="dui-auth-page" onSubmit={handleForgotPassword}>
      <div className="dui-auth-logo">
        <b>Doktor</b>UI
      </div>
      <div className="dui-auth-form">
        <div>
          <div className="dui-auth-title">Vytvorenie nového hesla</div>
          {error && (
            <div className="dui-auth-error">
              <div className="dui-auth-error-text">{error}</div>
            </div>
          )}

          <div className="dui-auth-form-fields-wrapper">
            <div className="dui-auth-form-fields">
              <div className="dui-auth-field">
                <div className="dui-auth-field-label">Nové heslo</div>
                <input
                  className="dui-auth-field-input"
                  type="password"
                  placeholder="Zadajte nové heslo..."
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="dui-auth-field">
                <div className="dui-auth-field-label">Potvrďte nové heslo</div>
                <input
                  className="dui-auth-field-input"
                  type="password"
                  placeholder="Potvrďte nové heslo..."
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <Button
                className="dui-auth-button"
                disabled={isLoading}
                onClick={handleForgotPassword}
                htmlType="submit"
              >
                {isLoading ? "Ukladám..." : "Uložiť nové heslo"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UpdatePasswordForm;
